export const SITE_EVENTS = {
    CREATED: 'site.created',
    IMPORTED: 'site.imported',
};
